<template>
    <ion-item lines="none">
        <ion-slides pager ref="multi" @ionSlidesDidLoad="setupMultiSlides()">
            <ion-slide>
                <big-stepper size="medium" label="Box Width" units="cm" @enter="nextSlide('box_length')" v-model="plan.width"/>
            </ion-slide>
            <ion-slide>
                <big-stepper ref="box_length" size="medium" label="Box Length" units="cm" @enter="nextSlide('box_height')" v-model="plan.length"/>
            </ion-slide>
            <ion-slide>
                <big-stepper ref="box_height" size="medium" label="Box Height" units="cm" @enter="nextSlide('box_weight')" v-model="plan.height"/>
            </ion-slide>
            <ion-slide>
                <big-stepper ref="box_weight" size="medium" label="Box Weight" units="kg" @enter="nextSlide('box_count')" v-model="plan.weight"/>
            </ion-slide>
            <ion-slide>
                <big-stepper ref="box_count" size="medium" label="Boxes like this" units="total" @enter="nextSlide('item_quantity')" v-model="plan.count"/>
            </ion-slide>
            <ion-slide>
                <big-stepper ref="item_quantity" size="medium" label="Items per Box" units="per box" @enter="nextSlide('pallet')" v-model="plan.per_box_quantity"/>
                <small v-if="plan.count > 0">
                    {{ plan.per_box_quantity }} per box, {{ plan.count }} x boxes = <strong>{{ maths }}</strong>
                    <ion-text color="danger" v-if="unboxed - total_quantity > 0">
                        and
                        {{ unboxed - total_quantity }} unboxed
                    </ion-text>
                </small>
                <small v-else>
                    Please set a box quantity
                </small>
            </ion-slide>
            <ion-slide v-if="isPallets">
                <big-stepper ref="pallet" size="medium" label="Pallet" units="#" v-model="plan.pallet"/>
            </ion-slide>
        </ion-slides>
    </ion-item>
</template>

<script>
import {IonItem, IonSlides, IonSlide, IonText} from '@ionic/vue';
import BigStepper from "@/components/BigStepper";
import {computed} from "vue";

export default {
    name: "MultiBoxPlan",
    emits: ['update:modelValue'],
    props: {
        isPallets: Boolean,
        unboxed: Number,
        modelValue: {
            type: Object,
            default() {
                return {
                    width: 0,
                    height: 0,
                    length: 0,
                    weight: 0,
                    count: 0,
                    per_box_quantity: 0,
                    pallet: 1
                };
            }
        }
    },
    components: {
        IonItem,
        BigStepper,
        IonSlides,
        IonSlide,
        IonText
    },
    computed: {
        total_quantity() {
            return this.plan.count * this.plan.per_box_quantity;
        },
        maths() {
            if (this.plan.count < 1) {
                return '0';
            }
            const whole = Math.floor(this.plan.per_box_quantity * this.plan.count);
            return whole + ' boxed';
        }
    },
    setup(props, {emit}) {
        // Explanation of how to get v-model working in Vue 3:
        // https://www.vuemastery.com/blog/vue-3-data-down-events-up/
        const plan = computed({
            get: () => props.modelValue,
            set: (value) => {
                emit('update:modelValue', value);
            }
        });
        return {plan};
    },
    methods: {
        async nextSlide(focus = '') {
            this.$refs['multi'].$el.slideNext().then(() => {
                if (focus) {
                    setTimeout(() => {
                        this.$refs[focus].focus();
                    }, 250);
                }
            });
        },
        setupMultiSlides() {
            this.$refs['multi'].$el.update();
        }
    }
}
</script>

<style scoped>
ion-slide {
    display: block;
}

.swiper-container {
    padding-bottom: 3em;
}
</style>
